import React, { useState, useEffect, useRef } from "react";
import { Tabs, Descriptions, Tag, Button, Image } from "antd";
import LaboratorySheet from "./LaboratorySheet";
import QuestionSheet from "./QuestionSheet";
import { Container, Row, Col } from "react-bootstrap";
import DisplayFile from "./DisplayFile";
import OneFileRecord from "./OneFileRecord";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import DisplayMultiplePage from "./DisplayMultiplePage";
import { Parser } from 'html-to-react';
import Common from "./includes/Common";
import MedFormVa from "./forms/MedFormVa";
import MedFormPe from "./forms/MedFormPe";
import MedFormJour from "./forms/MedFormJour";
import MedFormFhVa from "./forms/MedFormFhVa";
import MedFormFhPe from "./forms/MedFormFhPe";
import MedFormVaEn from "./forms/MedFormVaEn";
import MedFormPeEn from "./forms/MedFormPeEn";
import SignConsent from "./SignConsent";
import MedForm from "./forms/MedForm";
import MedFormEn from "./forms/MedFormEn";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var CompleteRecord = function CompleteRecord(_ref) {
  var candidat = _ref.candidat;
  var ref = useRef();
  var tabItems = [{
    key: 1,
    label: /*#__PURE__*/_jsx("b", {
      children: "LABORATOIRE"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: candidat && /*#__PURE__*/_jsx(LaboratorySheet, {
        candidat: candidat
      })
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsx("b", {
      children: "CONSULTATION"
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [candidat.medecine_questions && candidat.medecine_questions.form_type == 0 && /*#__PURE__*/_jsx(DisplayMultiplePage, {
        pageCount: 12,
        file_url: candidat.medecine_questions.file
      }), candidat.nationality.toLowerCase().indexOf("guin") > -1 && candidat.nationality.split(" ").length == 1 ? /*#__PURE__*/_jsx(MedForm, {
        readOnly: 1,
        formType: candidat.category,
        candidat: candidat,
        handler: function handler() {
          setDataChanged(true);
          setShowNewForm(false);
          notification.success({
            message: "Ok!",
            description: "Les donnés ont été sauvegardées"
          });
        }
      }) : /*#__PURE__*/_jsx(MedFormEn, {
        readOnly: 1,
        formType: candidat.category,
        candidat: candidat,
        handler: function handler() {
          setDataChanged(true);
          setShowNewForm(false);
          notification.success({
            message: "Ok!",
            description: "Les donnés ont été sauvegardées"
          });
        }
      })]
    })
  }, {
    key: 3,
    label: /*#__PURE__*/_jsx("b", {
      children: "IMAGERIE"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Container, {
          children: [/*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              children: /*#__PURE__*/_jsxs("div", {
                className: "infoBox",
                style: {
                  minHeight: "190px",
                  background: "#E6CFC0"
                },
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "RESULTAT"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    padding: "8px"
                  },
                  children: candidat.im_result && candidat.im_result.result != null && candidat.im_result.result != "" && candidat.im_result.result != "undefined" ? Parser().parse(candidat.im_result.result) : "NA"
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              children: /*#__PURE__*/_jsxs("div", {
                className: "infoBox",
                style: {
                  minHeight: "190px",
                  background: "#CDDFE6"
                },
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "CONCLUSION"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    padding: "8px"
                  },
                  children: candidat.im_result && candidat.im_result.conclusion != null && candidat.im_result.conclusion != "" && candidat.im_result.conclusion != "undefined" ? Parser().parse(candidat.im_result.conclusion) : "NA"
                })]
              })
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              children: [candidat.im_result && candidat.im_result.image_file && /*#__PURE__*/_jsx(Image, {
                className: "framed",
                src: Common.baseUrl + candidat.im_result.image_file,
                preview: false,
                width: "100%"
              }), candidat.im_result && candidat.im_result.attached_file && /*#__PURE__*/_jsx(DisplayMultiplePage, {
                pageCount: 1,
                file_url: candidat.im_result.attached_file
              })]
            })
          })]
        })
      })
    })
  }, {
    key: 4,
    label: /*#__PURE__*/_jsx("b", {
      children: "VISION TEST"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          children: /*#__PURE__*/_jsx(Descriptions, {
            column: 2,
            title: /*#__PURE__*/_jsx("b", {
              children: "INFORMATIONS"
            }),
            items: [{
              key: 1,
              label: /*#__PURE__*/_jsx("b", {
                children: "Binoculaire"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                  children: candidat.visio_test.binocular
                })
              })
            }, {
              key: 2,
              label: /*#__PURE__*/_jsx("b", {
                children: "Oeil Gauche"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                  children: candidat.visio_test.leftsight
                })
              })
            }, {
              key: 3,
              label: /*#__PURE__*/_jsx("b", {
                children: "Oeil droit"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                  children: candidat.visio_test.rightsight
                })
              })
            }, {
              key: 4,
              label: /*#__PURE__*/_jsx("b", {
                children: "VISION DES COULEURS"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: candidat.visio_test && (candidat.visio_test.colorseeing == 0 ? /*#__PURE__*/_jsx(Tag, {
                  color: "#f50",
                  children: "NON VALIDE"
                }) : /*#__PURE__*/_jsx(Tag, {
                  color: "#699C4E",
                  children: "VALIDE"
                }))
              })
            }, {
              key: 5,
              label: /*#__PURE__*/_jsx("b", {
                children: "TESTE D'EBLOUISSEMENT"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: candidat.visio_test && (candidat.visio_test.blowtest == 0 ? /*#__PURE__*/_jsx(Tag, {
                  color: "#f50",
                  children: "NON VALIDE"
                }) : /*#__PURE__*/_jsx(Tag, {
                  color: "#699C4E",
                  children: "VALIDE"
                }))
              })
            }, {
              key: 6,
              label: /*#__PURE__*/_jsx("b", {
                children: "CHAMPS PERIPHERIQUES"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: candidat.visio_test && (candidat.visio_test.peripheral == 0 ? /*#__PURE__*/_jsx(Tag, {
                  color: "#f50",
                  children: "NON VALIDE"
                }) : /*#__PURE__*/_jsx(Tag, {
                  color: "#699C4E",
                  children: "VALIDE"
                }))
              })
            }, {
              key: 7,
              label: /*#__PURE__*/_jsx("b", {
                children: "CONCLUSION"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                  children: candidat.visio_test.comment
                })
              })
            }]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          children: candidat.visio_test && /*#__PURE__*/_jsx(DisplayFile, {
            file_url: candidat.visio_test.attached_file
          })
        })]
      })
    })
  }, {
    key: 5,
    label: /*#__PURE__*/_jsx("b", {
      children: "AUDIO TEST"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5
        }), /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          children: candidat.audio_test && /*#__PURE__*/_jsx(DisplayFile, {
            file_url: candidat.audio_test.attached_file
          })
        })]
      })
    })
  }, {
    key: 6,
    label: /*#__PURE__*/_jsx("b", {
      children: "SPIROMETRIE"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: candidat.spirometrie != null && /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 5,
          md: 5,
          children: [candidat.spirometrie && (candidat.spirometrie.status == 0 ? /*#__PURE__*/_jsx(Tag, {
            color: "#f50",
            children: "NON VALIDE"
          }) : /*#__PURE__*/_jsx(Tag, {
            color: "#699C4E",
            children: "VALIDE"
          })), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsx("b", {
              children: "COMMENTAIRE"
            })
          }), candidat.spirometrie.comment != null && candidat.spirometrie.comment.length > 0 && /*#__PURE__*/_jsx("p", {
            children: candidat.spirometrie.comment
          }), candidat.spirometrie.comment != null && (candidat.spirometrie.comment == null || candidat.spirometrie.comment.length > 0 || candidat.spirometrie.comment == 'undefined') && /*#__PURE__*/_jsx("p", {
            children: "Aucun commentaire"
          })]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          children: candidat.spirometrie && /*#__PURE__*/_jsx(DisplayFile, {
            file_url: candidat.spirometrie.file
          })
        })]
      })
    })
  }, {
    key: 7,
    label: /*#__PURE__*/_jsx("b", {
      children: "DOSSIER"
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })]
      }), /*#__PURE__*/_jsx(OneFileRecord, {
        ref: ref,
        candidat: candidat
      })]
    })
  }];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Tabs, {
      items: tabItems,
      animated: true
    })
  });
};
export default CompleteRecord;